<template>
  <div id="main-content" class="container py-5">
    <div class="row">
      <div class="col-12">
        <h1 class="display-4 pb-3">Login</h1>
        <p>{{ status }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  title: 'Login',
  data() {
    return {
      status: 'Validating CAS authentication ticket...',
    };
  },
  mounted() {
    const vm = this;
    const ticket = this.$route.query.ticket;
    this.$store.dispatch('userLogin', { ticket }).then(() => {
      if (vm.$cookies.isKey('current_path')) {
        vm.$router.push(vm.$cookies.get('current_path'));
      } else {
        vm.$router.push({ name: 'Groups' });
      }
      vm.status = 'CAS ticket validation failed. Please try again.';
    });
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue